import type { DraftState } from './draft-state';

export async function blogDraftPreviewReady(read: () => Promise<DraftState>, updatedAt?: string, timeoutMs = 15_000): Promise<DraftState | null> {
  let expired = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<null>((resolve) => {
    timer = setTimeout(() => {
      expired = true;
      resolve(null);
    }, timeoutMs);
  });
  const poll = async () => {
    while (!expired) {
      const state = await read();
      if (expired || (!state.updatedAt && !state.wixPreviewPending)) return null;
      if (!state.wixPreviewPending && (!updatedAt || state.updatedAt === updatedAt)) return state;
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    return null;
  };
  try {
    return await Promise.race([poll(), timeout]);
  } catch {
    return null;
  } finally {
    expired = true;
    clearTimeout(timer);
  }
}
